(() => {
  const enhance = (content) => {
    if (content.dataset.accordionsEnhanced === 'true') return;

    const nodes = Array.from(content.children);
    if (!nodes.some((node) => node.tagName === 'H2')) return;

    const fragment = document.createDocumentFragment();
    let currentGroup;

    const createGroup = (heading) => {
      currentGroup = document.createElement('section');
      currentGroup.className = 'page-accordion__group';

      if (heading) {
        heading.classList.add('page-accordion__section-title');
        currentGroup.append(heading);
      } else {
        currentGroup.classList.add('page-accordion__group--untitled');
      }

      const body = document.createElement('div');
      body.className = 'page-accordion__group-content';
      currentGroup.append(body);
      fragment.append(currentGroup);
    };

    nodes.forEach((node) => {
      if (node.tagName === 'H2' && node.textContent.trim()) {
        createGroup(node);
        return;
      }

      if (!currentGroup && node.tagName === 'H3') {
        createGroup();
      }

      if (currentGroup) {
        currentGroup.querySelector('.page-accordion__group-content').append(node);
      } else {
        fragment.append(node);
      }
    });

    content.replaceChildren(fragment);

    content.querySelectorAll('.page-accordion__group-content').forEach((groupContent) => {
      const children = Array.from(groupContent.children);
      const accordionFragment = document.createDocumentFragment();
      let currentAccordion;

      children.forEach((node) => {
        if (node.tagName === 'H3') {
          currentAccordion = document.createElement('details');
          currentAccordion.className = 'page-accordion__item';

          const summary = document.createElement('summary');
          summary.innerHTML = node.innerHTML;
          currentAccordion.append(summary);

          const answer = document.createElement('div');
          answer.className = 'page-accordion__answer rte';
          currentAccordion.append(answer);
          accordionFragment.append(currentAccordion);
          return;
        }

        if (currentAccordion) {
          currentAccordion.querySelector('.page-accordion__answer').append(node);
        } else {
          accordionFragment.append(node);
        }
      });

      groupContent.replaceChildren(accordionFragment);
    });

    content.dataset.accordionsEnhanced = 'true';
  };

  const initialise = () => {
    document.querySelectorAll('[data-page-accordion-content]').forEach(enhance);
  };

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);
})();

